<template>
  <div>
    <BankReconciliationModal
      v-if="selectedTransaction"
      :selectedTransaction="selectedTransaction"
      @cancel="onModalClose"
    />

    <div class="bank-wrapper content--inner">
      <BankTransactionsSidebar />
      <div class="bank-table">
        <div class="bank-table-filters-wrap">
          <div class="bank-table-filters">
            <FilterBar
              cookieName="BankFilterOptionsVue"
              class="no-totals"
              filterBarType="bank"
              @change="filtersChanged"
              :mainFilters="['SearchFilter', 'DateRangeFilter', 'TransactionTypeFilter', 'TransactionAmountFilter']"
            />
          </div>
        </div>
        <div class="bank-table-wrap">
          <BankTransactionsTable
            v-if="selectedAccount"
            @row-clicked="selectTransaction"
            @refresh-transactions="$emit('update-transactions', false)"
            ref="BankTransactionsTable"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import FilterBar from '@/components/list_filters/FilterBar'
import GekkoButton from '@/components/GekkoButton'
import BankTransactionsSidebar from '@/components/bank/ui/BankTransactionsSidebar'
import BankReconciliationModal from '@/components/bank/ui/BankReconciliationModal'
import BankTransactionsTable from '@/components/bank/ui/BankTransactionsTable'
import BankTransactionService from '@/store/services/bank.transaction.service'

export default {
  name: 'BankTransactions',
  components: {
    FilterBar,
    GekkoButton,
    BankTransactionsSidebar,
    BankReconciliationModal,
    BankTransactionsTable,
  },
  data() {
    return {
      selectedTransaction: null
    }
  },
  computed: {
    ...mapGetters({
      getBankAccount: 'bankStore/getBankAccount',
      selectedAccount: 'bankStore/getSelectedAccount',
    }),
    isControlPanel() {
      return this.$route.path.includes('control-panel')
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.selectedTransaction = null
        this.onCreated()
      },
    },
  },
  created() {
    this.onCreated()
  },
  methods: {
    ...mapActions({
      resetCost: 'costs/resetCost',
    }),
    onCreated() {
      if (!this.$route.params.transaction_id) return
      
      BankTransactionService.retrieve(this.$route.params.transaction_id).then((response) => {
        this.selectedTransaction = response.data
      })
    },
    filtersChanged() {
      if (this.$refs['BankTransactionsTable']) this.$refs['BankTransactionsTable'].getTransactions()
    },
    selectTransaction(transaction) {
      const routeName = this.isControlPanel ? 'ControlPanelBankTransaction' : 'BankTransaction'
      this.$router.push({
        name: routeName,
        params: {
          transaction_id: transaction.id,
        },
      }).catch(() => {})
    },
    onModalClose(transaction) {
      const routeName = this.isControlPanel ? 'ControlPanelBank' : 'Bank'
      this.$router
        .push({
          name: routeName,
        })
        .catch(() => {})
      this.updateListTransaction(transaction)
      this.resetCost()
      this.selectedTransaction = null
    },
    updateListTransaction(transaction) {
      if (this.$refs['BankTransactionsTable']) this.$refs['BankTransactionsTable'].updateTransaction(transaction)
    },
  },
}
</script>

<style lang="scss" scoped>
.bank-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;

  .bank-table {
    padding: 0rem;
    flex: 1;
    overflow: auto;

    display: flex;
    flex-direction: column;

    .bank-table-filters-wrap {
      padding: 1rem;
      padding-bottom: 0;
    }

    .bank-table-filters {
      border-bottom: 1px solid $colorBorderDash;
    }

    .bank-table-wrap {
      padding: 1rem;
      padding-top: 0;
      overflow: auto;

      flex: 1;
    }

    .filterbar {
      margin-bottom: 0.5rem;
    }
  }

  @media (max-width: '768px') {
    flex-direction: column;
  }
}
</style>
